var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-root"},[_c('Header'),_c('section',{staticClass:"layout-main"},[_c('router-view',{ref:"children"})],1),_c('AiAssistantFloat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }